import { render, staticRenderFns } from "./MeasureDiscontinuedBadge.vue?vue&type=template&id=23e24cbc"
import script from "./MeasureDiscontinuedBadge.vue?vue&type=script&lang=js"
export * from "./MeasureDiscontinuedBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports